module.exports = __webpack_public_path__ + "static/media/linkedIn.2b47fd13.png";